/* GLLF builder mobile v1
   1. Live plant order builder: on phones the Back / Continue buttons stay at the bottom of the screen while a step is on
      screen, and pressing them brings you back to the top of the next step.
   2. Wholesale reservation (product pages only, not the Trade Desk): "Add more plants" moves below the reservation steps,
      with a link to it under the basket.
   3. Updated ordering-time wording in the Wholesale reservation. */
(function () {
  'use strict';
  if (window.__gllfBuilderMobile) return;
  window.__gllfBuilderMobile = 1;
  var LEAD = 'We recommend purchasing 6 months in advance to secure your space in the greenhouse. Most of our plants are grown to order, so they can take up to 6 months to fill out with good roots for planting. Earlier dates are welcome if we already have the plants growing in our greenhouse — we’ll confirm timing with you. Dates within 30 days must be paid in full. Dates 31 days or more out require a 50% deposit, with the balance due two weeks before we ship.';
  var PHONE = '(max-width: 749px)';

  var css = document.createElement('style');
  css.textContent =
    '@media ' + PHONE + '{' +
      '.gllf-order-builder__body,.gllf-lp{overflow:clip!important}' +
      '.gllf-lp [data-step-panel] .gllf-lp__flow-actions{position:sticky;bottom:0;z-index:6;background:#fff;margin-top:16px;padding:10px 0 calc(10px + env(safe-area-inset-bottom));box-shadow:0 -10px 14px -12px rgba(45,34,56,.45);display:flex!important;flex-direction:row!important;gap:10px;align-items:stretch}' +
      '.gllf-lp [data-step-panel] .gllf-lp__flow-actions>button{flex:1 1 0;margin:0!important;min-width:0}' +
      '.gllf-lp [data-step-panel] .gllf-lp__flow-actions>[data-flow-back]{order:1;flex:0 1 34%}' +
      '.gllf-lp [data-step-panel] .gllf-lp__flow-actions>[data-flow-next],.gllf-lp [data-step-panel] .gllf-lp__flow-actions>[data-order-protection-next]{order:2}' +
      'body.gllf-steps-on .gllf-basket-dock,body.gllf-steps-on .lg-launcher{bottom:calc(var(--gllf-bar-h,84px) + 10px)!important}' +
    '}' +
    '.gllf-hub-more-link{display:block;width:100%;margin:12px 0 0;padding:10px 14px;border:1px dashed rgba(127,98,157,.55);border-radius:12px;background:#fff;color:#4b3a5c;font:inherit;font-weight:600;text-align:center;cursor:pointer}' +
    '.gllf-wholesale-hub__catalog--last{margin-top:24px}';
  document.head.appendChild(css);

  /* ---------- 1. Order builder steps ---------- */
  function headerBottom() {
    var h = 0;
    document.querySelectorAll('header, sticky-header, .header-wrapper, #shopify-section-header, .shopify-section-header-sticky').forEach(function (el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 && r.bottom > 0 && r.bottom < innerHeight / 2) h = Math.max(h, r.bottom);
    });
    return h;
  }
  function barHeight(R) {
    var bar = R.querySelector('[data-step-panel]:not([hidden]) .gllf-lp__flow-actions');
    if (bar && bar.offsetHeight) document.body.style.setProperty('--gllf-bar-h', bar.offsetHeight + 'px');
  }
  function setupBuilder(R) {
    if (R.__gllfMobile) return;
    R.__gllfMobile = 1;
    var lastPress = 0;
    R.addEventListener('click', function (e) {
      if (e.target.closest('[data-flow-next],[data-flow-back],[data-order-protection-next],[data-step-nav]')) lastPress = Date.now();
    }, true);
    var lastStep = R.dataset.step;
    new MutationObserver(function () {
      if (R.dataset.step === lastStep) return;
      lastStep = R.dataset.step;
      if (Date.now() - lastPress > 2500) return;
      var target = R.querySelector('.gllf-lp__progress-label') || R.querySelector('[data-step-panel]:not([hidden])');
      if (!target) return;
      setTimeout(function () {
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerBottom() - 10;
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      }, 30);
    }).observe(R, { attributes: true, attributeFilter: ['data-step'] });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var on = en.isIntersecting && Number(R.dataset.step || 1) < 5 && window.matchMedia(PHONE).matches;
          document.body.classList.toggle('gllf-steps-on', on);
          if (on) barHeight(R);
        });
      }, { threshold: 0.15 }).observe(R);
      new MutationObserver(function () { if (Number(R.dataset.step || 1) >= 5) document.body.classList.remove('gllf-steps-on'); else setTimeout(function () { barHeight(R); }, 50); }).observe(R, { attributes: true, attributeFilter: ['data-step'] });
    }
    setupDefaultDate(R);
  }

  /* ---------- 4. Requested date starts on the next available date ----------
     When the shopper reaches the date step with no date yet, the builder's own earliest date is filled in. If the
     builder says that day can't work (season, pickup days, production schedule), its own "Use … instead" date is taken.
     Once the shopper picks a date themselves, it's never changed. */
  function setupDefaultDate(R) {
    var date = R.querySelector('[data-requested-date]'), sug = R.querySelector('[data-date-suggestion]');
    if (!date) return;
    var auto = null, busy = false;
    date.addEventListener('change', function (e) { if (e.isTrusted) auto = null; });
    date.addEventListener('input', function (e) { if (e.isTrusted) auto = null; });
    if (sug) sug.addEventListener('click', function (e) { if (e.isTrusted) auto = null; });
    function takeSuggestion() {
      if (!sug || sug.hidden || !sug.dataset.date || date.value !== auto) return;
      busy = true;
      sug.click();
      auto = date.value;
      busy = false;
    }
    function fill() {
      if (busy || date.value || R.__gllfDateFilled) return;
      var min = date.min || new Date(Date.now() + 864e5).toISOString().slice(0, 10);
      R.__gllfDateFilled = 1;
      date.value = min;
      auto = min;
      date.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(takeSuggestion, 60);
    }
    function onStep() { if (Number(R.dataset.step) === 2) setTimeout(fill, 80); }
    new MutationObserver(onStep).observe(R, { attributes: true, attributeFilter: ['data-step'] });
    if (sug) new MutationObserver(function () { setTimeout(takeSuggestion, 30); }).observe(sug, { attributes: true, attributeFilter: ['hidden', 'data-date'] });
    onStep();
  }
  function scanBuilders() {
    document.querySelectorAll('section.gllf-lp').forEach(function (R) { if (R.querySelector('[data-step-panel]')) setupBuilder(R); });
  }

  /* ---------- 2 + 3. Wholesale reservation ---------- */
  function hubPatch(C) {
    var P = C && C.prototype;
    if (!P || P.__gllfMobile || typeof P.enhance !== 'function') return;
    P.__gllfMobile = 1;
    var enhance = P.enhance;
    P.enhance = function () {
      var out = enhance.apply(this, arguments);
      try {
        var content = this.content;
        if (content) {
          var guide = content.querySelector('.gllf-wholesale-hub__date-guidance');
          if (guide && guide.textContent !== LEAD) { guide.dataset.short = '1'; guide.textContent = LEAD; }
          if (this.mode === 'product') {
            var main = content.querySelector('.gllf-wholesale-hub__main'),
                catalog = main && main.querySelector(':scope > .gllf-wholesale-hub__catalog'),
                basket = main && main.querySelector(':scope > .gllf-wholesale-hub__basket');
            if (catalog && basket && main.lastElementChild !== catalog) {
              main.appendChild(catalog);
              catalog.classList.add('gllf-wholesale-hub__catalog--last');
              if (!basket.querySelector('.gllf-hub-more-link')) {
                var more = document.createElement('button');
                more.type = 'button';
                more.className = 'gllf-hub-more-link';
                more.textContent = '＋ Add more plants (below the reservation steps)';
                more.addEventListener('click', function () {
                  var cat = content.querySelector('.gllf-wholesale-hub__catalog');
                  if (cat) cat.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
                basket.appendChild(more);
              }
            }
          }
        }
      } catch (e) { /* layout help only */ }
      return out;
    };
  }
  if (window.customElements) customElements.whenDefined('great-lakes-wholesale-hub').then(function () { hubPatch(customElements.get('great-lakes-wholesale-hub')); });

  function boot() {
    scanBuilders();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scanBuilders(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
